'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _types$RULE$types$WOR;

var _types = require('../../types');

var types = _interopRequireWildcard(_types);

var _rule = require('./rule');

var _rule2 = _interopRequireDefault(_rule);

var _word = require('./word');

var _word2 = _interopRequireDefault(_word);

var _alt = require('./alt');

var _alt2 = _interopRequireDefault(_alt);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

exports.default = (_types$RULE$types$WOR = {}, _defineProperty(_types$RULE$types$WOR, types.RULE, _rule2.default), _defineProperty(_types$RULE$types$WOR, types.WORD, _word2.default), _defineProperty(_types$RULE$types$WOR, types.ALTERNATIVE, _alt2.default), _types$RULE$types$WOR);


//////////////////
// WEBPACK FOOTER
// ./~/jspeech/lib/stringify/types/index.js
// module id = 241
// module chunks = 0